import { connect } from 'react-redux';
import RegisterPersonalInfoForm from './register-personal-info-form';

const mapStateToProps = state => ({
  portalUrl: state.appsettings.andromeda.portalUrl,
  companyName: state.appsettings.company.name,
});

export default connect(
  mapStateToProps,
  null
)(RegisterPersonalInfoForm);
